import { Formik, Form, Field } from 'formik';
import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaGoogle, FaTwitter } from 'react-icons/fa';
import { FcGoogle } from 'react-icons/fc';
import RegularButton from '../../components/Buttons/RegularButton';
import { NavLink, useNavigate } from 'react-router-dom';
import { useGoogleAuthDetailsMutation, useSsoLoginUserMutation } from '../../redux/services/authApi';
import { useDispatch } from 'react-redux';
import { setUser } from '../../redux/slices/authSlice';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Box } from '@mui/material';
import { useFindUsernameMutation } from '../../redux/services/userApi';
import { FacebookAuthProvider, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import toast from 'react-hot-toast';
import { auth, facebook, google } from '../../config/firebase';

type Props = {
  guestLoginResponse?: any
};

const SignUpSchema = Yup.object().shape({
  name: Yup.string().max(40).required(' Name is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string().required('Password is required').min(6, 'Password is too short'),
  confirmpassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});

const GuestSignUp = (props: Props) => {
  const dispatch = useDispatch();
  const handleLoginSubmit = () => { };
  const navigate = useNavigate();
  const [signUp, signUpResponse] = useSsoLoginUserMutation();
  const [signUpData, setSignUpData] = useState<null | any>(null);
  const [authenticationData, setAuthenticationData] = useState<null | any>(
    null
  );
  const [findUsername, findUsernameResponse] = useFindUsernameMutation();
  const [googleData, setGoogleData] = useState<null | any>(null);
  const [googleAuthDetails, googleAuthResponse] =
    useGoogleAuthDetailsMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [terms, setTerms] = useState(false);

  const handleLogin = async (values: any) => {
    await signUp({
      email: values.email,
      name: values.name,
      password: values.password,
      // merchantId: 104,
    });
  };
  useEffect(() => {
    if (findUsernameResponse.isSuccess) {
      if (findUsernameResponse.data == true) {
        signUp({
          email: signUpData?.email,
          name: signUpData?.name,
          password: signUpData?.password,
        });
      }
      if (findUsernameResponse.data == false) {
        setStatusCode({ type: "error", code: "USER_ALREADY_EXIST" });
      }
    }
  }, [findUsernameResponse.isSuccess]);

  const loginWithSocialMedia = (
    email: string,
    name: string,
    gaccessToken: string,
    gidToken: string,
    gid: string,
    gpicture: string
  ) => {
    signUp({
      email: email,
      name: name,
      gaccessToken: gaccessToken,
      gid: gidToken,
      gidToken: gid,
      gimageUrl: gpicture,
    });
  };

  useEffect(() => {
    if (googleAuthResponse.isSuccess) {
      loginWithSocialMedia(
        googleData?.email,
        googleAuthResponse.data.name,
        authenticationData?.accessToken,
        authenticationData?.idToken,
        authenticationData?.idToken,
        googleAuthResponse.data.picture
      );
    } else if (googleAuthResponse.isError) {
      toast.success("Error ocurred");
    }
  }, [googleAuthResponse.isSuccess, googleAuthResponse.isError]);

  const SignInWithGoogle = () => {
    let google_provider = google;
    signInWithPopup(auth, google_provider)
      .then((result) => {
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential?.accessToken;
        setAuthenticationData(credential?.accessToken);
        const user = result.user;
        setGoogleData(user);
        if (result.user.emailVerified === true) {
          googleAuthDetails({
            token: token,
          });
        }
      })
      .catch((error) => {
        toast.success(error.code, error.message);
        const errorCode = error.code;
        const errorMessage = error.message;
        const email = error.customData.email;
        const credential = GoogleAuthProvider.credentialFromError(error);
      });
  };

  const SignInWithFaceBook = () => {
    const facebook_provider = facebook;
    signInWithPopup(auth, facebook_provider)
      .then((result) => {
        const user = result.providerId;
        const credential = FacebookAuthProvider.credentialFromResult(result);
        setAuthenticationData(credential?.accessToken);
        const accessToken = credential?.accessToken;
        if (credential?.accessToken !== null) {
          signUp({
            email: result?.user?.providerData?.[0]?.email,
            name: result?.user?.displayName,
            fbAccessToken: authenticationData?.accessToken,
            fbId: authenticationData?.idToken,
            fbImageUrl: result?.user?.photoURL,
          });
        }
      })
      .catch((error) => {
        toast.success(error.code, error.message);
        const errorCode = error.code;
        const errorMessage = error.message;
        const credential = FacebookAuthProvider.credentialFromError(error);
      });
  };

  useEffect(() => {
    if (googleAuthResponse.isSuccess) {
      loginWithSocialMedia(
        googleData?.email,
        googleAuthResponse.data.name,
        authenticationData?.accessToken,
        authenticationData?.idToken,
        authenticationData?.idToken,
        googleAuthResponse.data.picture
      );
    } else if (googleAuthResponse.isError) {
      toast.success("Error ocurred");
    }
  }, [googleAuthResponse.isSuccess, googleAuthResponse.isError]);

  useEffect(() => {
    if (signUpResponse.isSuccess) {
      props.guestLoginResponse(signUpResponse.isSuccess)
      dispatch(setUser(signUpResponse.data));
      localStorage.setItem('user', JSON.stringify(signUpResponse.data));
      localStorage.setItem('isLoggedIn', 'true');
    }
  }, [signUpResponse.isSuccess]);

  return (
    <div
    >

      <div className="w-full">
        <div>
          <Formik
            validationSchema={SignUpSchema}
            initialValues={{
              name: '',
              password: '',
              confirmpassword: "",
              email: '',
            }}
            onSubmit={handleLogin}
          >
            {({ handleBlur, handleChange, handleSubmit, values, touched, errors }) => (
              <div>
                <div className="mt-3">
                                    <TextField
                                      label="Full Name"
                                      variant="outlined"
                                      size="small"
                                      type="text"
                                      id={"name"}
                                      name={"name"}
                                      value={values.name}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      placeholder="Enter your name"
                                      className="w-full "
                                      error={Boolean(
                                        touched.name && errors.name
                                      )}
                                      helperText={
                                        touched.name && errors.name
                                      }
                                      sx={{
                                        backgroundColor: "#E2E2E2",
                                        borderRadius: "30px",
                                        mb: 2,
                                        height: "45px", // Slightly reduced height for a compact look
                                        "& .MuiInputBase-root": {
                                          display: "flex",
                                          alignItems: "center", // Centers input text vertically
                                          height: "100%",
                                          padding: "0 12px", // Reducing padding inside input container
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "30px",
                                          height: "100%",
                                          "& input": {
                                            padding: "6px 8px", // Reduced padding inside input field
                                          },
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "transparent" },
                                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                          top: "50%",
                                          left: "12px", // Moves label closer to start
                                          transform: "translateY(-50%)", // Centers label vertically
                                        },
                                        "& .MuiInputLabel-shrink": {
                                          top: 6, // Moves label up when focused
                                          transform: "translateY(-100%) scale(0.75)",
                                        },
                                        "& .MuiFormHelperText-root": {
                                          position: "absolute",
                                          bottom: "-18px", // Adjusted for better spacing
                                          fontSize: "12px",
                                          color: "red",
                                        },
                                      }}
                                    />
                                  </div>
                <div className="mt-3">
                                    <TextField
                                      label="Email"
                                      size="small"
                                      variant="outlined"
                                      type="text"
                                      id={"email"}
                                      name={"email"}
                                      value={values.email}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      placeholder="Enter your email"
                                      className="w-full "
                                      error={Boolean(
                                        touched.email && errors.email
                                      )}
                                      helperText={
                                        touched.email && errors.email
                                      }
                                      sx={{
                                        backgroundColor: "#E2E2E2",
                                        borderRadius: "30px",
                                        mb: 2,
                                        height: "45px", // Slightly reduced height for a compact look
                                        "& .MuiInputBase-root": {
                                          display: "flex",
                                          alignItems: "center", // Centers input text vertically
                                          height: "100%",
                                          padding: "0 12px", // Reducing padding inside input container
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "30px",
                                          height: "100%",
                                          "& input": {
                                            padding: "6px 8px", // Reduced padding inside input field
                                          },
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "transparent" },
                                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                          top: "50%",
                                          left: "12px", // Moves label closer to start
                                          transform: "translateY(-50%)", // Centers label vertically
                                        },
                                        "& .MuiInputLabel-shrink": {
                                          top: 6, // Moves label up when focused
                                          transform: "translateY(-100%) scale(0.75)",
                                        },
                                        "& .MuiFormHelperText-root": {
                                          position: "absolute",
                                          bottom: "-18px", // Adjusted for better spacing
                                          fontSize: "12px",
                                          color: "red",
                                        },
                                      }}
                                    />
                
                                  </div>
                <div className="mt-3">
                                    <TextField
                                      label="Password"
                                      variant="outlined"
                                      size="small"
                                      type="password"
                                      id={"password"}
                                      name={"password"}
                                      value={values.password}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      placeholder="Enter your password"
                                      className="w-full "
                                      error={Boolean(
                                        touched.password && errors.password
                                      )}
                                      helperText={
                                        touched.password && errors.password
                                      }
                                      sx={{
                                        backgroundColor: "#E2E2E2",
                                        borderRadius: "30px",
                                        mb: 2,
                                        height: "45px", // Slightly reduced height for a compact look
                                        "& .MuiInputBase-root": {
                                          display: "flex",
                                          alignItems: "center", // Centers input text vertically
                                          height: "100%",
                                          padding: "0 12px", // Reducing padding inside input container
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "30px",
                                          height: "100%",
                                          "& input": {
                                            padding: "6px 8px", // Reduced padding inside input field
                                          },
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "transparent" },
                                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                          top: "50%",
                                          left: "12px", // Moves label closer to start
                                          transform: "translateY(-50%)", // Centers label vertically
                                        },
                                        "& .MuiInputLabel-shrink": {
                                          top: 6, // Moves label up when focused
                                          transform: "translateY(-100%) scale(0.75)",
                                        },
                                        "& .MuiFormHelperText-root": {
                                          position: "absolute",
                                          bottom: "-18px", // Adjusted for better spacing
                                          fontSize: "12px",
                                          color: "red",
                                        },
                                      }}
                                    />
                                  </div>
                <div className="mt-3">
                                    <TextField
                                      label={"Confirm Password"}
                                      variant="outlined"
                                      size="small"
                                      type="password"
                                      name={"confirmpassword"}
                                      value={values.confirmpassword}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      placeholder="Enter your name"
                                      className="w-full "
                                      error={Boolean(
                                        touched.confirmpassword && errors.confirmpassword
                                      )}
                                      helperText={
                                        touched.confirmpassword && errors.confirmpassword
                                      }
                                      sx={{
                                        backgroundColor: "#E2E2E2",
                                        borderRadius: "30px",
                                        mb: 2,
                                        height: "45px", // Slightly reduced height for a compact look
                                        "& .MuiInputBase-root": {
                                          display: "flex",
                                          alignItems: "center", // Centers input text vertically
                                          height: "100%",
                                          padding: "0 12px", // Reducing padding inside input container
                                        },
                                        "& .MuiOutlinedInput-root": {
                                          borderRadius: "30px",
                                          height: "100%",
                                          "& input": {
                                            padding: "6px 8px", // Reduced padding inside input field
                                          },
                                          "& fieldset": { borderColor: "transparent" },
                                          "&:hover fieldset": { borderColor: "transparent" },
                                          "&.Mui-focused fieldset": { borderColor: "transparent" },
                                        },
                                        "& .MuiInputLabel-root": {
                                          top: "50%",
                                          left: "12px", // Moves label closer to start
                                          transform: "translateY(-50%)", // Centers label vertically
                                        },
                                        "& .MuiInputLabel-shrink": {
                                          top: 6, // Moves label up when focused
                                          transform: "translateY(-100%) scale(0.75)",
                                        },
                                        "& .MuiFormHelperText-root": {
                                          position: "absolute",
                                          bottom: "-18px", // Adjusted for better spacing
                                          fontSize: "12px",
                                          color: "red",
                                        },
                                      }}
                                    />
                                  </div>
                <div className="lg:flex sm:flex-row items-center gap-5 mt-5 ">
                  <RegularButton
                    onClick={() => {
                      handleSubmit();
                    }}
                    className="w-full"
                    title={'Sign Up'}
                  />
                </div>
                {/* <div >
                                    <p className="mb-0 text-center text-gray-500 py-6">Or sign up with</p>
                                    <div className="flex items-center justify-center gap-2">
                                        <button className="shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-blue-500">
                                            <FaTwitter />
                                        </button>
                                        <button className=" shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-blue-500"
                                        onClick={SignInWithGoogle}>
                                            <FcGoogle />
                                        </button>
                                        <button className="shadow-xl bg-white-200 hover:bg-blue-300 transition-all h-10 w-10 rounded-lg flex items-center justify-center text-[#2f477a]"
                                        onClick={SignInWithFaceBook}>
                                            <FaFacebookF />
                                        </button>
                                    </div>
                                </div> */}
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default GuestSignUp;
